import * as moment from 'moment';

import { LicenseStatus } from './license-status';
import { Address } from '@app/domain/model/address';

/**
 * Seller (Fisherman) information.
 *
 * @author Warlock, AIS.PL
 */
export class Seller {

  readonly businessAddress: Address;

  readonly businessName: string;

  readonly expirationDate: Date;

  readonly licenseNumber: number;

  readonly name: string;

  readonly status: LicenseStatus;

  static fromJSON(jsonObject: any): Seller {
    const result = Object.create(Seller.prototype);

    return Object.assign(result, jsonObject, {
      expirationDate: jsonObject.expirationDate ? moment(jsonObject.expirationDate).toDate() : null,
      licenseNumber: jsonObject.licenseNumber ? Number(jsonObject.licenseNumber) : null,
      status: jsonObject.status ? LicenseStatus.fromString(jsonObject.status) : null,
      name: jsonObject.name instanceof Object ? `${jsonObject.name.lastName}, ${jsonObject.name.firstName}` : jsonObject.name,
      businessAddress: jsonObject.businessAddress ? Address.fromJSON(jsonObject.businessAddress) : null,
    });
  }

}
